import React from "react";
import { Link } from "react-router-dom";
import { FaEnvelope, FaPhone } from "react-icons/fa";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div className="footer-content">
        <div className="footer-section">
          <h3>Neralen</h3>
          <p>
            Η τέχνη της ζαχαροπλαστικής σε κάθε δημιουργία. Ανακαλύψτε
            αυθεντικές συνταγές και επαγγελματικές συμβουλές από έμπειρους
            pastry chefs.
          </p>
        </div>

        <div className="footer-section">
          <h3>Γρήγορες Συνδέσεις</h3>
          <ul>
            <li>
              <Link to="/">Αρχική</Link>
            </li>
            <li>
              <Link to="/about">Σχετικά με Εμάς</Link>
            </li>
            <li>
              <Link to="/contact">Επικοινωνία</Link>
            </li>
            <li>
              <Link to="/privacy-policy">Πολιτική Απορρήτου</Link>
            </li>
            <li>
              <Link to="/terms-conditions">Όροι Χρήσης</Link>
            </li>
            <li>
              <Link to="/refund-policy">Πολιτική Επιστροφών</Link>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Επικοινωνία</h3>
          <p>
            Email: <a href="mailto:neralen@hotmail.com">neralen@hotmail.com</a>
          </p>
          <p>
            <a href="https://wa.me/302130281863">WhatsApp</a>
          </p>
          <p>
            <a href="https://viber.me/302130281863">Viber</a>
          </p>
          <p>
            <FaPhone /> +302130281863
          </p>
          <p>
            Armatolon ke Klefton 48
            <br />
            114 71, Αμπελόκηποι, Greece
          </p>
          <p>ΑΦΜ: 23031216</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {currentYear} Neralen. Όλα τα δικαιώματα διατηρούνται.</p>
      </div>
    </footer>
  );
}

export default Footer;
